import $ from 'cash-dom';
import Ajax from '../components/ajax';
import Popup from '../components/popup';
import spinner from '../components/spinner';
import Utils from '../components/Utils';
import DateHelper from '../components/DateHelper';
import Autocomplete from '../components/autocomplete';
import FormBuilderHandler from './form/FormBuilderHandler';
import TaboolaPetFormTracker from './TaboolaPetFormTracker';

const ZIPCODE_LOOKUP_DELAY = 300;
const ZIPCODE_PATTERN = /^\d{5}(?:-\d{4})?$/;

class PetInfoForm {
	constructor() {
		this._$petInfoForm = $('form.pet-form');
		this._postId = $('body').attr('data-post-id');
		this._quote_ids = this._buildSaveAndGetQuoteIds();
	}

	handle() {
		if (this._$petInfoForm.length === 0) {
			return;
		}

		this._sendAloomaQuizStep_0_Event();

		this._$petInfoForm.each((i, form) => {
			const $form = $(form);
			this._handlePetName($form);
			this._handlePetTypeChange($form);
			this._handleZipcodeStateLookup($form);

			const Form = new FormBuilderHandler($form.attr('id'));
			const updateStepsProgress = this._initStepsProgress(Form, $form);
			this._handleForm(Form, $form, updateStepsProgress);
			this._initAutocomplete($form);
		});
	}

	_initStepsProgress(Form, $form) {
		const progress = document.getElementById($form.attr('id') + '_progress');

		if (!progress) {
			return () => {};
		}

		const $progress = $(progress);
		const stepsCount = $progress.find('.step-progress-num').length;
		const progressBar = $progress.find('.steps-progress-mid-bar').get(0);

		$progress.find('.prev-step-btn').on('click', (e) => {
			e.preventDefault();
			Form.prevStep();
		});

		const update = () => {
			const $step = $form.find('.step-holder.active');
			const isExcludedFromProgress = $step.hasClass('step-excluded-from-progress');

			progress.hidden = isExcludedFromProgress;
			progress.style.display = isExcludedFromProgress ? 'none' : '';

			if (isExcludedFromProgress || !stepsCount || !progressBar) {
				return;
			}

			const progressStep = parseInt($step.attr('data-progress-step'), 10);
			const progressWidth = Math.min(100, Math.ceil((100 / stepsCount) * (progressStep + 1)));

			progressBar.style.setProperty('--progress-width', progressWidth + '%');
		};

		update();

		return update;
	}

	_handlePetName($form) {
		const $input = $form.find('[name="petName"]');

		if (!$input.length) {
			return;
		}

		const updatePetName = () => {
			$form.find('.pet-name-value').text(($input.val() || '').trim());
		};

		$input.on('input change', updatePetName);
		updatePetName();
	}

	_handleForm(Form, $form, updateStepsProgress) {
		const taboola = new TaboolaPetFormTracker();
		Form.onValid((e) => {
			const form = e.target;
			const formData = new FormData(form);

			spinner.show();

			const dataObj = {
				petName: formData.get('petName'),
				petType: formData.get('petType'),
				breed: formData.get('breed'),
				petGender: formData.get('petGender'),
				ageYears: $form.find('[name="ageYears"]').val(),
				ageMonths: $form.find('[name="ageMonths"]').val(),
				zipCode: formData.get('zipCode'),
				email: formData.get('email'),
				postId: this._postId,
				quote_ids: this._quote_ids,
			};

			this._setSessionStorageData(dataObj);
			this._sendAloomaFormSubmitEvent(dataObj, $form.closest('.ppc-single-vendor').data('vendor-id'));

			Ajax.post(ajaxurl, {
				action: 'form-data-crypto-handler',
				data: dataObj,
				job: 'encrypt',
			}, function (response) {
				if (response) {
					taboola.start();
					taboola.complete();
					const currentUrl = new URL(window.location.href);
					currentUrl.searchParams.set('form', 'results');
					currentUrl.searchParams.set('form-data', response);

					window.location.href = currentUrl.toString();
				}
			}, 'json').fail(function (err) {
				const popup = new Popup();
				popup.show(tr('Sorry, some error occurred. Please, try again later.'));
			}).always(function () {
				spinner.hide();
			});
		});

		Form.onBeforeStepChange(({step, $form}) => {
			Promise.resolve().then(() => {
				const activeStep = Number($form.find('.step-holder.active').attr('id').replace('step_', ''));
				if (activeStep > step) {
					taboola.start();
				}
				updateStepsProgress();
				this._toggleStartStepState($form);
			});
			this._sendAloomaQuizChangeEvent(step, $form);
		});
	}

	_toggleStartStepState($form) {
		const isStartStep = $form.find('.step-holder.active').hasClass('pet-start-step');

		$('#ppc_page').toggleClass('pet-form-started', !isStartStep);
	}

	_sendAloomaQuizStep_0_Event() {
		Alooma.aloomaSendEvent('quiz_change', {
			pageview_id: Alooma.aloomaPageData.pageview_id,
			quiz: {step: 'step_0'},
		});
	}

	_sendAloomaQuizChangeEvent(currentStep, $form) {
		const currentStepData = this._buildAndGetCurrentStepData(currentStep, $form);
		const vendorId = $form.closest('.ppc-single-vendor').data('vendor-id')
		//all questions of a form screen share its step, the first screen (DOM #step_0) is step_1
		const quiz = {step: 'step_' + (Number(currentStep) + 1)};

		const aloomaData = {
			pageview_id: Alooma.aloomaPageData.pageview_id,
			vendorId: typeof vendorId === 'undefined' ? null : vendorId,
			quiz: quiz,
		};

		for (const [question, answer] of Object.entries(currentStepData)) {
			quiz.question = question;
			quiz.answer = (question === 'zipCode' || question === 'email') ? 'completed' : answer;

			Alooma.aloomaSendEvent('quiz_change', aloomaData);
		}
	}

	_buildAndGetCurrentStepData(step, $form) {
		const stepData = {};
		const inputsSelector = `#step_${step} fieldset input`
			+ `, #step_${step} fieldset select`
			+ `, #step_${step} fieldset .styleable-select`;

		$form.find(inputsSelector).each((i, field) => {
			const $field = $(field);

			//only the selected radio of a group holds the answer
			if (field.type === 'radio' && !field.checked) {
				return;
			}

			stepData[$field.attr('name')] = $field.val();
		});

		return stepData;
	}

	_initAutocomplete($form) {
		const selectedPetType = $form.find('[name="petType"]:checked').val()
		const containerId = $form.attr('id') + '-breed-autocomplete';

		const $autocompleteInput = $form.find('.autocomplete-input');
		const autocompleteObj = $autocompleteInput.length ? $autocompleteInput.get(0).customObjectAutocomplete : null;

		if (autocompleteObj) {
			autocompleteObj.setData(selectedPetType === 'cat' ? catBreedsJson : dogBreedsJson)
		}
	}

	_handlePetTypeChange($form) {
		const self = this;

		$('[name="petType"]', $form).on('change', function() {
			$form.find('input[name="breed"]').val('');

			self._initAutocomplete($form);
		});
	}

	_handleZipcodeStateLookup($form) {
		const $input = $form.find('[name="zipCode"]');

		if (!$input.length) {
			return;
		}

		const $fieldset = $input.closest('.zip-code');
		const $state = $fieldset.find('.zipcode-state');
		let lookupTimeoutId = null;
		let lookupSequence = 0;

		const resetState = () => {
			$fieldset.removeClass('error has-state');
			$fieldset.find('.error-message').text('');
			$state.text('');
		};

		$input.on('input', () => {
			const zipcode = ($input.val() || '').trim();
			const currentLookupSequence = ++lookupSequence;

			clearTimeout(lookupTimeoutId);
			resetState();

			if (!ZIPCODE_PATTERN.test(zipcode)) {
				return;
			}

			lookupTimeoutId = setTimeout(() => {
				Ajax.post(ajaxurl, {
					action: 'get-state-by-zipcode',
					zipcode,
				}, (response) => {
					const currentZipcode = ($input.val() || '').trim();

					if (currentLookupSequence !== lookupSequence || currentZipcode !== zipcode) {
						return;
					}

					if (response?.state) {
						$state.text(response.state);
						$fieldset.addClass('has-state');
						return;
					}

					$fieldset.addClass('error');
					$fieldset.find('.error-message').text(tr('Zipcode does not exist'));
				}, 'json').fail(() => {
					const currentZipcode = ($input.val() || '').trim();

					if (currentLookupSequence === lookupSequence && currentZipcode === zipcode) {
						$fieldset.addClass('error');
						$fieldset.find('.error-message').text(
							tr('Sorry, some error occurred. Please, try again later.')
						);
					}
				});
			}, ZIPCODE_LOOKUP_DELAY);
		});
	}

	_buildSaveAndGetQuoteIds() {
		const quote_ids = [];

		$('.vendors-container .ppc-single-vendor').each(function (i, vendor) {
			const $vendor = $(vendor);
			quote_ids.push(Alooma.aloomaPageData.pageview_id + '|' + $vendor.data('vendor-id'));
		});

		const quoteIdsJson = JSON.stringify(quote_ids);
		Utils.setCookie('quote_ids', quoteIdsJson, {expires: DateHelper.tomorrow()});

		return quote_ids;
	}

	_setSessionStorageData(dataObj) {
		const savedData = {
			"1": {"petType": dataObj['petType']},
			"2": {"petGender": dataObj['petGender']},
			"3": {"petName": dataObj['petName']},
			"4": {"breed": dataObj['breed']},
			"5": {"ageYears": dataObj['ageYears'], "ageMonths": dataObj['ageMonths']},
			"6": {"zipCode": dataObj['zipCode']},
			"7": {"email": dataObj['email']},
		};

		sessionStorage.setItem('pet_info_form_quiz_data', JSON.stringify(savedData));
		sessionStorage.setItem('first_page_view', Alooma.aloomaPageData.pageview_id);
	}

	_sendAloomaFormSubmitEvent(dataObj, vendorId) {
		const aloomaDetails = {
			breed: dataObj['breed'],
			age: (parseInt(dataObj['ageYears']) * 12) + parseInt(dataObj['ageMonths']),
			type: dataObj['petType'],
			gender: dataObj['petGender'],
		};

		Alooma.aloomaSendEvent('form_submit', {
			pageview_id: Alooma.aloomaPageData.pageview_id,
			quote_ids: this._quote_ids,
			details: aloomaDetails,
			vendorId: typeof vendorId === 'undefined' ? null : vendorId,
		});
	}
}

export default PetInfoForm;
